import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import { Reveal } from "../components/Reveal";
import { useSEO } from "../lib/useSEO";

export default function Reflexoes() {
  useSEO({ title: "Reflexões", description: "Um espelho por dia. Textos curtos e honestos sobre mentalidade, escolhas e evolução." });
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-32" data-testid="reflexoes-page">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Blog</p>
        <h1 className="mt-6 font-serif text-5xl text-zinc-100 sm:text-6xl">Reflexões</h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
          Um espelho por dia. Textos curtos, diretos e honestos sobre mentalidade, escolhas e evolução.
        </p>
      </Reveal>

      {loading ? (
        <p className="mt-20 font-serif text-zinc-500" data-testid="posts-loading">Carregando…</p>
      ) : (
        <div className="mt-20 flex flex-col">
          {posts.map((post, i) => (
            <Reveal key={post.id} delay={i * 0.05}>
              <Link
                to={`/reflexoes/${post.slug}`}
                className="group grid gap-6 border-t border-gold/15 py-10 transition-colors hover:bg-[#0a0a0a] md:grid-cols-12 md:items-center md:gap-10"
                data-testid={`post-row-${post.slug}`}
              >
                <span className="font-serif text-2xl text-gold/40 md:col-span-1">{String(i + 1).padStart(2, "0")}</span>
                <div className="md:col-span-3">
                  {post.cover_url && (
                    <div className="aspect-[16/10] overflow-hidden border border-gold/10">
                      <img src={post.cover_url} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                  )}
                </div>
                <div className="md:col-span-7">
                  <h2 className="font-serif text-2xl text-zinc-100 transition-colors group-hover:text-gold lg:text-3xl">{post.title}</h2>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-zinc-500">{post.excerpt}</p>
                </div>
                <div className="md:col-span-1 md:text-right">
                  <ArrowUpRight className="inline text-gold/40 transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-gold" size={22} />
                </div>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-gold/15" />
        </div>
      )}
    </div>
  );
}
